<template>
	<div>
		<div class="library-book-head-color" v-if="!book.cover_display" :style="{'background-color': book.cover_color}">
		</div>
		<div class="library-book-head-photo preloader" v-if="!loaded && book.cover_display">
			<div class="library-book-heading-text">
				<div class="content-placeholder">
					<div class="container-loading h-line-1">
						<div class="line width-100"></div>
					</div>
					<div class="container-loading p-lines-18">
						<div class="line width-100"></div>
					</div>
				</div>
			</div>
			<div class="library-book-photo"></div>
		</div>
		
		<div class="library-book-head-photo" v-if="loaded && book.cover_display">
			<div class="library-book-heading-text">
				<h1 v-html="book.title"></h1>
				<p v-html="book.subheader"></p>
			</div>
			<div class="library-book-photo" :style="{ 'background-image': 'url(' +book.cover.url+ ')' }"></div>
		</div>
		<section class="library-book-content">
			<div class="container">
				<div class="wp-content-section">
					<div class="book-heading" v-html="book.title"></div>
					<div class="row">
						<div class="col-12 col-lg-7 col-xl-6">
								<div class="wp-content">
									<div class="content-placeholder" v-if="!loaded">
										<div class="container-loading h-line-1">
											<div class="line width-40"></div>
										</div>
										<div class="container-loading p-lines-18">
											<div class="line"></div>
											<div class="line"></div>
											<div class="line"></div>
											<div class="line"></div>
											<div class="line"></div>
										</div>
									</div>
									<div v-else>
										<div class="wp-heading">
											<h1 v-html="book.chapters[navigation.active].title"></h1>
										</div>
										<div class="wp-text-container justified" v-html="book.chapters[navigation.active].content">
										</div>
										<LibraryBookController mode='compact'></LibraryBookController>
									</div>
								</div>
							</div>
						<div class="col-12 col-lg-5 col-xl-5">
							<div class="aside-content-section">
								<LibraryBookController mode='full'></LibraryBookController>
								<div class="read-more-container" v-if="loaded && book.read_more.length">
									<h2 class="read-more-heading">
										Читайте так же
									</h2>
									<a
										:href="`/library/books/${readMoreItem.book.ID}`"
										
										class="read-more-link-item" 
										v-for="(readMoreItem, index) in book.read_more" 
										:key="index"
									>	
										<span v-html="readMoreItem.book.post_title" ></span>
										<div class="read-more-cover" :style="{ 'background-image': 'url(' +readMoreItem.cover+ ')' }">
										</div>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		
	</div>
</template>

<script>
import store from "../../store/";
import LibraryBookController from "../LibraryBookController";

export default {
	name: "LibraryBook",
	store,
	components: {
		LibraryBookController
	},
	created() {
		this.$store.dispatch("LibraryBook/fetchBook", {
			chapterId: Number(this.$route.params.chapterId),
			bookId: this.$route.params.bookId
		});
	},
	computed: {
		loaded() {
			return this.$store.state["LibraryBook"].loaded;
		},
		book() {
			return this.$store.state["LibraryBook"].book;
		},
		navigation() {
			return this.$store.state["LibraryBook"].navigation;
		}
	},
};
</script>



// WEBPACK FOOTER //
// src/components/LibraryBook/index.vue